import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    padding: 20px;
    border-radius: 20px;
    gap: 20px;
    margin-top: 16px;
    flex-direction: column;
    background: ${COLORS.neutral_00};
    border: 1px solid ${COLORS.neutral_10};
`;

export const MainInfoWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const MainInfo = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const AvatarWrapper = styled('div')`
    position: relative;
`;

export const AvatarCornerIcon = styled('div')`
    position: absolute;
    top: 49px;
    left: 49px;
    padding: 3px;
    border-radius: 50%;
    background: ${COLORS.neutral_00};
`;

export const NameWrapper = styled('div')`
    display: flex;
    gap: 8px;
    align-items: center;
`;
